<template>

    <div class="exam-wrap">

        <h1 class="seat-number ng-tns-c279-2 ng-star-inserted" style="">1</h1>

        <div class="wrap-entry-block  mt-2 mt-sm-5 mb-4" v-if="isLogin == 0">
            <div class="logo-title"></div>
        </div>
        <div class="entry-block sign-in shadow-sm pt-5 pb-5" v-if="isLogin == 0">
            <div class="sign-in">准&nbsp;考&nbsp;证&nbsp;号</div>
            <div class="sign-input">
                <el-input v-model="code" placeholder="请输入准考证号"></el-input>
                <div class="sign-notice" v-if="showCode == 1">{{ txt }}</div>
            </div>
            <div :class="checked == 1 ? 'check-view check' : 'check-view'">
                <span class="check-box" @click="clickCheck()"></span>
                <span class="check-box-info" @click="clickCheck()"></span>
            </div>
            <el-button type="danger" @click="login">登录</el-button>
        </div>

        <div class="wrap-entry-block" v-if="isLogin == 1">
            <div class="session-title mt-2 mb-2">2025年全国导游资格考试</div>
            <div class="entry-block person-info mb-3">
                <div class="entry-block-title">考生信息</div>
                <div class="row info mt-sm-5 mb-sm-5">
                    <div class="col-md-5 col-sm-12 mb-2 wrap-img text-right">
                        <div class="default-photo ng-star-inserted"><img height="200"
                                src="../../../public/images/touxiang.png">
                        </div>
                    </div>
                    <div class="col-md-7 col-12 mb-2 mt-2 mt-md-0">
                        <div class="ng-star-inserted">
                            <div class="wrap-info full-name ng-star-inserted"><span class="text-right full-name"><span
                                        class="info-name">姓名</span><span>：</span></span><span
                                    class="info-cont full-name">练习考生</span></div>
                            <div class="wrap-info gender ng-star-inserted"><span class="text-right gender"><span
                                        class="info-name">性别</span><span>：</span></span><span
                                    class="info-cont mb-1 mb-sm-2 gender">男</span></div>

                            <div class="wrap-info permit ng-star-inserted"><span class="text-right permit"><span
                                        class="info-name">准考证号</span><span>：</span></span><span
                                    class="info-cont mb-1 mb-sm-2 permit">1234</span></div>

                            <div class="wrap-info identity_id ng-star-inserted"><span
                                    class="text-right identity_id"><span
                                        class="info-name">证件号码</span><span>：</span></span><span
                                    class="info-cont mb-1 mb-sm-2 identity_id">1234567890</span>
                            </div>
                            <div class="wrap-info subject ng-star-inserted"><span class="text-right subject"><span
                                        class="info-name">考试科目</span><span>：</span></span><span
                                    class="info-cont mb-1 mb-sm-2 subject">模拟练习</span></div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center mt-3 mb-4">
                    <div class="col-3 col-offset-3 text-center ng-star-inserted">
                        <el-button type="primary" @click="goNotice">确认</el-button>
                    </div>
                    <div class="col-3 text-center">
                        <el-button type="info" @click="dialogOutVisible = true">取消</el-button>
                    </div>
                </div>
            </div>
            <div class="tip">
                <div class="tip-detail">若您的个人信息存在错误，请联系现场监考人员进行处理</div>
            </div>
        </div>

        <el-dialog title="提示" :visible.sync="dialogOutVisible" width="50%">
            <span>确认取消并返回登录页？</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="isLogin = 0; dialogOutVisible = false; checked = 0; code = '';">确
                    定</el-button>
                <el-button type="primary" @click="dialogOutVisible = false">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>请确认是否已按要求关闭手机等电子设备，并上交指定位置！</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="注意事项：" :visible.sync="centerDialogVisible" width="40%" center>
            <div class="addLoginIntro-ct">
                <div class="section">注意事项：</div>
                <div class="section">请使用以下准考证号登录本机考练习系统，进行机考模拟练习：</div>
                <div class="id-view section">
                    <p><span>准考证号</span>：<span>1234</span></p>
                </div>
                <div class="section" style="color: red">此准考证号仅限在本机考练习系统使用。</div>
                <div class="section" style="color: red">机考练习只用于熟悉机考作答环境，使用的<strong>题目并非正式试题，考生无需关注题目内容。</strong></div>
                <div class="section">本模拟考试系统要求计算机浏览器为 Edge87及以上，Chrome 87及以上，Firefox 80及以上，Mac Safari
                    12.0及以上或其他对应内核的浏览器。</div>
                <div class="section">打开本模拟考试系统后，请按F11键
                    开启全屏模式（测试版可以通过最小化等操作切换到计算机桌面，而正式版考试时，考生无法切换屏幕，屏幕会被锁定，这里的F11开启全屏为模拟正式考试场景，优化测试体验）。</div>
                <div class="section">阅读完注意事项后，请点击下方“确定”按钮。</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>

export default {
    data() {
        return {
            dialogVisible: false,
            dialogOutVisible: false,
            centerDialogVisible: true,
            checked: 0,
            showCode: 0,
            code: '1234',
            txt: '',
            isLogin: 0,
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        let random = Math.floor(Math.random() * 100);
        this.mecoSeat = random;
        sessionStorage.setItem("access-mecoSeat", random);
    },
    methods: {
        clickCheck() {
            this.checked = !this.checked;
        },

        login() {
            if (this.checked == 0) {
                this.dialogVisible = true;
                return false;
            }

            if (this.code == '') {
                this.showCode = 1;
                this.txt = "准考证号不能为空";
                return false;
            }

            if (this.code == '1234') {
                this.isLogin = 1;
                sessionStorage.removeItem("access-mecoPapers");
            } else {
                this.txt = "请输入正确的准考证号";
            }
        },
        goNotice() {
            this.$router.push({
                path: "/guide/notice",
                query: {
                    paper_id: this.paper_id,
                },
            });
            //this.$router.push("/guide/notice");
        },
    },
};
</script>
<style>
body {
    line-height: 1.6;
}

html,
body {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: url(../../../public/images/guide/bg.jpg) #f0f5ff no-repeat center !important;
    background-size: 100% 100% !important;
    font-family: Microsoft YaHei, Helvetica, Tahoma, Arial, Hiragino Sans GB, Hiragino Sans GB W3, STXihei, STHeiti, Heiti, SimSun, sans-serif;
}

.wrap-entry-block {
    min-height: 270px;
    padding: 120px 0 30px;
    margin: 0 auto;
}

.sign-notice {
    color: #dc3545;
    font-size: 16px;
    height: 32px;
    content: "";
}

.logo-title {
    background: url(../../../public/images/guide/title.png) no-repeat center;
    padding: 0 50px 15px;
    font-size: 0 !important;
    height: 90px;
}

.mb-sm-5,
.my-sm-5 {
    margin-bottom: 3rem !important;
}

.mt-md-0,
.my-md-0 {
    margin-top: 0 !important;
}

.mt-2,
.my-2 {
    margin-top: 0.5rem !important;
}

.col-3 {
    flex: 0 0 25%;
    max-width: 25%;
}

.mt-sm-5,
.my-sm-5 {
    margin-top: 3rem !important;
}

.mb-3,
.my-3 {
    margin-bottom: 1rem !important;
}

.info {
    margin: 0;
    color: var(--ac-border, #333);
}

.row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.mt-sm-5,
.my-sm-5 {
    margin-top: 3rem !important;
}

.mb-4,
.my-4 {
    margin-bottom: 1.5rem !important;
}

.col-md-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
}

.col-md-7,
.col-12,
.col-md-5 {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
}

.wrap-info {
    text-align: left;
    line-height: 42px;
}

.seat-number {
    font-size: 80px;
}

.entry-block {
    background: transparent;
    display: flex;
    flex-direction: column;
    width: 100% !important;
    text-align: center;
    max-width: none;
    overflow: visible;
}

.seat-number {
    color: #fe6e5f;
    font-size: 80px;
    text-align: right;
    position: absolute;
    font-weight: 500;
    right: 10px;
    top: -10px;
    z-index: 1;
}

.sign-in {
    color: #182548;
    font-size: 24px;
    font-weight: 500;
    display: block;
    text-align: center;
}

.entry-block .el-input {
    width: 320px;
    margin: 10px 0 10px 0;
}

.entry-block .el-button {
    margin: 30px 0 0 0;
    width: 120px !important;
}

.sign-input {
    margin: 10px 0 40px 0;
}

.text-right {
    text-align: right !important;
}

.mt-md-0,
.my-md-0 {
    margin-top: 0 !important;
}

.mb-2,
.my-2 {
    margin-bottom: 0.5rem !important;
}

.col-md-7 {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
}

.check-view {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
}

.check-box {
    width: 20px;
    height: 20px;
    display: block;
    border: 1px solid #000;
    background: #fff;
    margin-right: 10px;
    position: relative;
}

.check-box-info {
    display: inline-block;
    height: 24px;
    width: 435px;
    background: url(../../../public/images/guide/txt.png) transparent no-repeat center !important;
}

.check .check-box:before {
    content: "";
    width: 6px;
    height: 15px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    display: block;
    position: absolute;
    left: 6px;
    top: 0px;
    transform: rotate(45deg);
}

.exam-wrap {
    height: 100%;
    width: 100%;
    background-size: 100% auto;
    overflow: auto;
    position: relative;
    top: 0;
}

.addLoginIntro-ct {
    overflow: auto;
    max-height: 500px;
}

.addLoginIntro-ct .id-view {
    padding: 0 0 0 1rem;
}

.addLoginIntro-ct .section {
    margin: 0 0 1rem 0 !important;
}




.wrap-entry-block .session-title {
    padding: 0 50px 15px;
}

.wrap-entry-block .session-title {
    font-size: 30px;
    text-align: center;
    padding: 0 6rem 15px;
    line-height: 1.5;
    font-weight: 700;
}

.person-info {
    max-width: 900px;
}

.wrap-entry-block .entry-block {
    background: var(--ac-bg, #fff);
    box-shadow: 0 0 20px #abb2db80;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    border-radius: 10px;
}

.wrap-entry-block .entry-block-title {
    color: var(--ac-border, #383e50);
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    height: 48px;
    line-height: 48px;
    margin-bottom: 15px;
    margin-top: 20px;
}


.tip {
    margin: 30px auto;
    text-align: center;
}

.tip .tip-detail {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    color: #383e50;
    font-size: 14px;
    background-color: #e7edff;
    border-radius: 15px;
    padding: 0 20px;
}
</style>
